import { useMemo } from "react";
import { defineMessages, useIntl } from "react-intl";
import { ILogger } from "cayo.ui/lib/esm/utils/logger";
import { IJsonForm } from "@cayo/shared/api/types/schema";
import { ActionFormProps } from "./types";
import { evaluateJsExpression } from "../../scheme/transforms/js-expression-evaluator";
import { objectUtils } from "@cayo/shared/utils/object";

export const useDynamicTitle = (
  props: ActionFormProps & IJsonForm & { object?: any },
  log: ILogger
) => {
  const intl = useIntl();
  const { title, externalObjects, multipleTitle, object } = props;

  const calculatedTitle = useMemo(() => {
    let result: string;
    if (title && externalObjects?.length) {
      try {
        if (externalObjects.length > 1 && multipleTitle) {
          result = multipleTitle;
        } else {
          const externalObject = objectUtils.cloneObject(props.externalObjects) as any[];
          externalObject.forEach((o) => {
            if (!o.DisplayName) {
              o.DisplayName = findFirstNonEmptyNamedProperty(o);
            }
          });

          result = evaluateJsExpression(title, {
            selectedObjects: externalObject,
            model: object,
          });
        }
      } catch (e) {
        log.error("Error evaluating dynamic title", e);
        result = `Error: ${title}`;
      }
    } else {
      result = title ?? intl.formatMessage(confirmMessages.confirm);
    }

    return result;
  }, [props]);

  return calculatedTitle;
};

const confirmMessages = defineMessages({
  confirm: {
    defaultMessage: "Confirm",
    id: "dialogs.confirm",
  },
});

const findFirstNonEmptyNamedProperty = (o: any) => {
  const nameValue = o["Name"] || o["SamAccountName"];
  if (nameValue) {
    return nameValue;
  }

  const lookedKey = Object.keys(o).find((k) =>
    k.toLowerCase().indexOf("name") >= 0 && o[k] ? o[k] : undefined
  );

  return lookedKey ? o[lookedKey] : "Unknown";
};
